function ppModernInit(root) {
  if (!root) return null;

  // Teardown scaffolding. The section used to register a window scroll listener
  // and three observers per run with no way to remove them, so every re-render
  // in the theme editor leaked another set.
  var ac = new AbortController();
  var observers = [];
  var timers = [];
  function on(target, type, fn, opts) {
    var o = opts ? Object.assign({}, opts) : {};
    o.signal = ac.signal;
    target.addEventListener(type, fn, o);
  }
  function observe(cb, opts) {
    var io = new IntersectionObserver(cb, opts);
    observers.push(io);
    return io;
  }

  // --- Hero photo reveal safety net -----------------------------------------
  // The photo sits at opacity:0 until its inline onload fires. On an eager,
  // high-priority image the load can beat the handler, and the bottle then
  // never appears at all. Cheap check, catastrophic failure avoided.
  var heroPhoto = root.querySelector('.ppm-hero__photo');
  if (heroPhoto) {
    var revealHero = function () { heroPhoto.classList.add('loaded'); };
    if (heroPhoto.complete) revealHero();
    on(heroPhoto, 'load', revealHero);
    on(heroPhoto, 'error', revealHero);
    timers.push(setTimeout(revealHero, 3000));
  }

  // --- Note image fallback ---------------------------------------------------
  // Was six inline onerror attributes, each of which required 'unsafe-inline' in
  // a script-src CSP. `error` does not bubble, so this listens in the capture
  // phase instead; the fallback URL arrives as data on the section root.
  var noteFallback = root.getAttribute('data-note-fallback');
  if (noteFallback) {
    function applyNoteFallback(img) {
      if (!img || img.tagName !== 'IMG') return;
      if (!img.hasAttribute('data-pp-note-img') || img.hasAttribute('data-pp-fallback-used')) return;
      img.setAttribute('data-pp-fallback-used', '');
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      var w = parseInt(img.getAttribute('width'), 10) || 64;
      img.src = noteFallback + '?width=' + (w * 2);
    }
    on(root, 'error', function (e) { applyNoteFallback(e.target); }, { capture: true });
    // This script is deferred, so an image that already failed during parse never
    // reaches the listener above — the inline onerror it replaced had no such gap.
    // complete && naturalWidth === 0 is exactly that case.
    root.querySelectorAll('[data-pp-note-img]').forEach(function (img) {
      if (img.complete && img.naturalWidth === 0) applyNoteFallback(img);
    });
  }

  // --- Reveal animations -----------------------------------------------------
  // Deliberately the FIRST feature initialised. The section hides itself by
  // default — .ppm-rv, .ppm-perf__row, .ppm-perf__tag, .ppm-hero__photo and
  // .ppm-letter all start at opacity:0 — so whatever runs before this block
  // holds the entire page hostage: one throw in the variant selector, the
  // keyboard contract or the sticky bar and the visitor gets a dark rectangle
  // where a 300 EUR product page should be. This block depends only on `root`,
  // `observe` and `reduce`, so it costs nothing to run it before the buy path.
  // (JS being absent entirely is handled in Liquid, by a <noscript> rule.)
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce && 'IntersectionObserver' in window) {
    var io = observe(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('v');
          // Staggered children
          if (e.target.classList.contains('ppm-pyr')) {
            e.target.querySelectorAll('.ppm-tier').forEach(function (tier, i) { setTimeout(function(){ tier.classList.add('v'); }, i * 150); });
            e.target.querySelectorAll('.ppm-note').forEach(function (n, i) { setTimeout(function(){ n.classList.add('v'); }, 400 + i * 80); });
          }
          if (e.target.classList.contains('ppm-perf')) {
            e.target.querySelectorAll('.ppm-perf__row').forEach(function (r, i) { setTimeout(function(){ r.classList.add('v'); }, i * 120); });
            e.target.querySelectorAll('.ppm-perf__tag').forEach(function (t, i) { setTimeout(function(){ t.classList.add('v'); }, 600 + i * 60); });
          }
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    root.querySelectorAll('.ppm-rv, .ppm-rv-l, .ppm-rv-r, .ppm-rv-mask').forEach(function (el) { io.observe(el); });
  } else {
    root.querySelectorAll('.ppm-rv, .ppm-rv-l, .ppm-rv-r, .ppm-rv-mask').forEach(function (el) { el.classList.add('v'); });
    root.querySelectorAll('.ppm-tier, .ppm-note, .ppm-perf__row, .ppm-perf__tag').forEach(function (el) { el.classList.add('v'); });
  }

  // --- Server data -----------------------------------------------------------
  // Liquid cannot run in an external asset, so the section renders variants and
  // translated strings into a JSON island and this file reads them. priceText is
  // pre-formatted through the `money` filter, so it carries the shop's
  // money_format and the active market's currency.
  var dataEl = root.querySelector('[data-pp-modern-data]');
  var DATA = { t: {}, variants: [] };
  try { if (dataEl) DATA = JSON.parse(dataEl.textContent); } catch (e) {}
  var T = DATA.t || {};

  var variants = DATA.variants || [];
  function findVariant(id) { return variants.find(function (v) { return v.id === id; }); }

  // --- Variant select (desktop + mobile sync) -------------------------------
  var formInput = root.querySelector('[data-pp-variant-id]');
  var priceEl   = root.querySelector('[data-pp-price]');
  var mpriceEl  = root.querySelector('[data-pp-mprice]');
  var atcBtn    = root.querySelector('[data-pp-atc]');
  var atcText   = root.querySelector('[data-pp-atc-text]');
  var mAtcBtn   = root.querySelector('[data-pp-mobile-atc]');
  var ctaBtn    = root.querySelector('[data-pp-cta-atc]');
  var ctaText   = root.querySelector('[data-pp-cta-atc-text]');
  var ctaPrice  = root.querySelector('[data-pp-cta-price]');
  var live      = root.querySelector('[data-pp-live]');

  // --- La photo suit la contenance choisie ----------------------------------
  // Le 50 ml et le 10 ml ne sont pas le même flacon, et beaucoup de références
  // ont leur photo par format. La fiche montrait la photo principale quoi qu'on
  // choisisse : on pouvait acheter un 10 ml en regardant un 50 ml.
  //
  // Toutes les contenances n'ont PAS d'image — le 2 ml presque jamais. Dans ce
  // cas on remet la photo principale plutôt que de laisser celle du format
  // précédent, qui serait un mensonge silencieux.
  var heroImg = root.querySelector('.ppm-hero__photo');
  var photoOrigine = heroImg ? {
    src: heroImg.getAttribute('src'),
    srcset: heroImg.getAttribute('srcset'),
    alt: heroImg.getAttribute('alt'),
    w: heroImg.getAttribute('width'),
    h: heroImg.getAttribute('height')
  } : null;

  // La photo ne change QUE sur un choix explicite. Au chargement, l'image
  // principale — souvent la photo mise en scène, choisie par le marchand — est
  // remplacée par le packshot du format présélectionné : on perdait la belle
  // image d'ouverture sans que personne l'ait demandé. Le drapeau ne se lève
  // qu'au clic.
  var choixUtilisateur = false;

  function poserPhoto(img) {
    if (!heroImg || !photoOrigine || !choixUtilisateur) return;
    var cible = img
      ? { src: img.src,
          srcset: img.s400 + ' 400w, ' + img.s600 + ' 600w, ' + img.src + ' 800w, ' + img.s1200 + ' 1200w',
          alt: img.alt, w: img.w, h: img.h }
      : photoOrigine;
    if (heroImg.getAttribute('src') === cible.src) return;   // déjà la bonne
    // Les dimensions intrinsèques sont reposées AVEC la source : deux flacons
    // n'ont pas le même rapport, et sans elles la page saute à chaque choix.
    heroImg.setAttribute('width', cible.w);
    heroImg.setAttribute('height', cible.h);
    heroImg.setAttribute('srcset', cible.srcset || '');
    heroImg.setAttribute('alt', cible.alt || '');
    heroImg.setAttribute('src', cible.src);
  }

  // Précommande par contenance : une contenance encore en stock se vend en
  // « Ajouter au panier », celle qui ne reste qu'en stock futur en
  // « Précommander », avec la date et la propriété de ligne (voir la section).
  // Sans `preco` dans les données (ancien thème en cache), on garde T.atc.
  function labelAchat(v) {
    if (!v || v.preco === undefined) return T.atc;
    return v.preco ? (T.preco || T.atc) : (T.atcPlain || T.atc);
  }
  function majPreco(v) {
    if (!v || v.preco === undefined) return;
    // Une contenance épuisée n'affiche pas de date d'expédition à côté de « Épuisé ».
    var on = !!(v.preco && v.available);
    root.querySelectorAll('[data-pp-preco-field]').forEach(function (i) { i.disabled = !on; });
    root.querySelectorAll('[data-pp-preco-note]').forEach(function (p) { p.style.display = on ? 'flex' : 'none'; });
  }

  function selectVariant(id) {
    var v = findVariant(id);
    if (!v) return;
    if (formInput) formInput.value = v.id;
    poserPhoto(v.image);

    // Update URL
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }

    // Update price (live) — one source of truth, so the page cannot show two
    // prices for one product.
    var taxSpan = '<span class="ppm-hero__price-tax">' + T.ttc + '</span>';
    if (priceEl)  priceEl.innerHTML  = v.priceText + taxSpan;
    if (mpriceEl) mpriceEl.innerHTML = v.priceText + taxSpan;
    // innerHTML, not textContent: money_format may legitimately carry markup.
    if (ctaPrice) ctaPrice.innerHTML = v.available ? ('· ' + v.priceText + ' ' + T.ttc) : '';

    // Update buttons
    root.querySelectorAll('.ppm-variants__btn').forEach(function (b) {
      var isMatch = parseInt(b.getAttribute('data-variant-id'), 10) === v.id;
      b.classList.toggle('active', isMatch);
      b.setAttribute('aria-checked', isMatch ? 'true' : 'false');
    });
    root.querySelectorAll('.ppm-hero-m-bar__vbtn').forEach(function (b) {
      var isMatch = parseInt(b.getAttribute('data-variant-id-m'), 10) === v.id;
      b.classList.toggle('active', isMatch);
      b.setAttribute('aria-checked', isMatch ? 'true' : 'false');
      // Chips scroll horizontally: bring the choice made upstairs into view.
      if (isMatch && b.scrollIntoView) {
        b.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'auto' });
      }
    });

    // ATC state — all three buy controls move together, including the closing
    // CTA, which previously stayed live and priced while the hero read "Épuisé".
    var label = v.available ? labelAchat(v) : T.soldout;
    majPreco(v);
    if (atcBtn)  { atcBtn.disabled  = !v.available; if (atcText) atcText.textContent = label; }
    if (mAtcBtn) { mAtcBtn.disabled = !v.available; mAtcBtn.textContent = label; }
    if (ctaBtn)  { ctaBtn.disabled  = !v.available; if (ctaText) ctaText.textContent = label; }
  }

  // A sold-out chip used to swallow the click in silence, which reads as a
  // frozen page — to a screen reader it is indistinguishable from one.
  function announceUnavailable(title) {
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = title + ', ' + T.oosShort; }, 60);
  }

  function bindChip(b, attr) {
    on(b, 'click', function () {
      // Une contenance épuisée se choisit quand même. Le clic était avalé ici,
      // ce qui figeait la photo sur toute référence entièrement en rupture — et
      // il y en a beaucoup. Voir SON flacon et SON prix n'engage rien : le
      // chemin d'achat reste fermé, selectVariant() désactivant les trois
      // boutons et écrivant « Épuisé » à partir de v.available.
      if (b.classList.contains('ppm-oos')) {
        announceUnavailable((b.textContent || '').trim());
      }
      choixUtilisateur = true;
      selectVariant(parseInt(b.getAttribute(attr), 10));
    });
  }
  root.querySelectorAll('.ppm-variants__btn').forEach(function (b) { bindChip(b, 'data-variant-id'); });
  root.querySelectorAll('.ppm-hero-m-bar__vbtn').forEach(function (b) { bindChip(b, 'data-variant-id-m'); });

  // --- Radiogroup keyboard contract -----------------------------------------
  // role="radiogroup" makes assistive tech announce "use arrow keys", but every
  // chip was its own tab stop and the arrows did nothing. Roving tabindex: one
  // stop for the group, arrows move and activate through the same path as a
  // click, so a sold-out chip announces instead of selecting either way.
  function wireRadioGroup(selector) {
    var chips = [].slice.call(root.querySelectorAll(selector));
    if (chips.length < 2) return;

    function setRoving() {
      var activeIdx = chips.findIndex(function (c) { return c.classList.contains('active'); });
      if (activeIdx === -1) activeIdx = 0;
      chips.forEach(function (c, i) { c.tabIndex = i === activeIdx ? 0 : -1; });
    }
    setRoving();

    chips.forEach(function (chip, i) {
      on(chip, 'keydown', function (e) {
        var next = null;
        switch (e.key) {
          case 'ArrowRight': case 'ArrowDown': next = (i + 1) % chips.length; break;
          case 'ArrowLeft':  case 'ArrowUp':   next = (i - 1 + chips.length) % chips.length; break;
          case 'Home': next = 0; break;
          case 'End':  next = chips.length - 1; break;
          default: return;
        }
        e.preventDefault();
        chips[next].focus();
        chips[next].click();
      });
      // Clicking or activating anywhere in the group moves the tab stop with it.
      on(chip, 'click', setRoving);
    });
    return setRoving;
  }
  var rovingHero   = wireRadioGroup('.ppm-variants__btn');
  var rovingMobile = wireRadioGroup('.ppm-hero-m-bar__vbtn');
  // Selecting from one group has to move the other group's tab stop too.
  on(root, 'click', function () {
    if (rovingHero) rovingHero();
    if (rovingMobile) rovingMobile();
  });

  // Mobile ATC triggers the form submit.
  // Not form.submit(): that bypasses the submit event, skipping both the guard
  // below and any cart interceptor the theme installs.
  var atcForm = root.querySelector('[data-pp-form]');
  if (mAtcBtn) {
    on(mAtcBtn, 'click', function () {
      if (!atcForm) return;
      if (atcForm.requestSubmit) atcForm.requestSubmit();
      else if (atcBtn) atcBtn.click();
    });
  }

  // --- Submit guard + pending state -----------------------------------------
  // Submission is a full page navigation, so there is a real window in which an
  // impatient thumb fires the request three times. Nothing said it was working.
  if (atcForm) {
    var submitting = false;
    on(atcForm, 'submit', function (e) {
      if (submitting) { e.preventDefault(); return; }
      submitting = true;
      [atcBtn, mAtcBtn, ctaBtn].forEach(function (b) { if (b) b.disabled = true; });
      if (atcText) atcText.textContent = T.adding;
      if (mAtcBtn) mAtcBtn.textContent = T.adding;
      if (ctaText) ctaText.textContent = T.adding;
      if (live) live.textContent = T.adding;
      // If the navigation never happens (offline, blocked, back-forward cache),
      // hand the controls back rather than leaving a dead button.
      setTimeout(function () {
        if (!submitting) return;
        submitting = false;
        var v = findVariant(parseInt(formInput && formInput.value, 10));
        var label = (!v || v.available) ? labelAchat(v) : T.soldout;
        [atcBtn, mAtcBtn, ctaBtn].forEach(function (b) { if (b) b.disabled = !!(v && !v.available); });
        if (atcText) atcText.textContent = label;
        if (mAtcBtn) mAtcBtn.textContent = label;
        if (ctaText) ctaText.textContent = label;
      }, 8000);
    });
    on(window, 'pageshow', function (e) {
      if (!e.persisted) return;
      submitting = false;
      var v = findVariant(parseInt(formInput && formInput.value, 10));
      if (v) selectVariant(v.id);
    });
  }

  // --- Mobile sticky buy bar -------------------------------------------------
  // Appears once the hero's own buy block has scrolled away, so the two never
  // compete, and reserves its measured height at the foot of the page.
  var mBar     = root.querySelector('[data-pp-mbar]');
  var heroForm = root.querySelector('[data-pp-form]');

  if (mBar && heroForm && 'IntersectionObserver' in window) {
    var syncBarHeight = function () {
      if (!root.classList.contains('ppm-has-mbar')) return;
      root.style.setProperty('--ppm-mbar-h', mBar.offsetHeight + 'px');
    };

    var ioBar = observe(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        mBar.classList.toggle('is-on', show);
        root.classList.toggle('ppm-has-mbar', show);
        if (show) syncBarHeight();
        else root.style.removeProperty('--ppm-mbar-h');
      });
    }, { rootMargin: '0px 0px -20% 0px' });

    ioBar.observe(heroForm);
    on(window, 'resize', syncBarHeight, { passive: true });
    on(window, 'orientationchange', syncBarHeight, { passive: true });
  }

  // Animate perf bars on view (unified)
  var perfBars = root.querySelectorAll('.ppm-perf__bar');
  if (perfBars.length && !reduce && 'IntersectionObserver' in window) {
    var ioBars = observe(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var delay = parseInt(e.target.closest('.ppm-perf__row').getAttribute('data-score'), 10) * 50;
          setTimeout(function () { e.target.style.transform = 'scaleX(' + (parseFloat(e.target.getAttribute('data-fill')) / 100) + ')'; }, delay);
          ioBars.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });
    perfBars.forEach(function (b) { ioBars.observe(b); });
  } else {
    perfBars.forEach(function (b) { b.style.transform = 'scaleX(' + (parseFloat(b.getAttribute('data-fill')) / 100) + ')'; });
  }

  // --- FAQ accordion ---------------------------------------------------------
  // The panel animates on grid-template-rows now, so its height is never
  // measured or written from here: no scrollHeight read, no re-measure on
  // resize, orientation change or late webfont, and nothing to clip.
  root.querySelectorAll('[data-pp-faq]').forEach(function (q) {
    var a = q.nextElementSibling;
    if (!a) return;
    on(q, 'click', function () {
      var open = q.classList.toggle('open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      a.classList.toggle('is-open', open);
    });
  });

  // Preselect variant from URL
  var params = new URL(window.location.href).searchParams;
  var preId = params.get('variant');
  if (preId) selectVariant(parseInt(preId, 10));

  // ===== POLISH v2 =========================================================

  // --- Scroll progress bar ------------------------------------------------
  var progress = document.querySelector('[data-pp-progress]');
  if (progress) {
    var ticking = false;
    function updateProgress() {
      var scrolled = window.scrollY;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(scrolled / max * 100, 100) : 0;
      progress.style.transform = 'scaleX(' + (pct / 100) + ')';
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { requestAnimationFrame(updateProgress); ticking = true; }
    }, { passive: true });
    updateProgress();
  }

  // --- Word-by-word title reveal ------------------------------------------
  // This split used to go down to the character, with every letter its own
  // inline-block. An inline-block is a formatting boundary: the browser cannot
  // kern across one, and it cannot form a ligature across one either. So on a
  // 60px Fraunces italic title — a high-contrast face whose whole character
  // lives in its letterfit — every pair came out unkerned. "Ta", "Vo", "Ay"
  // visibly fell apart, and it was worst at exactly the size where it shows.
  //
  // The word is the right grain. Kerning and ligatures survive inside it (the
  // only place they matter — inter-word pairs carry almost nothing), the
  // cascade still reads as a cascade, and the last beat lands at 200 + n×90ms
  // for n words instead of n characters: ~0.5s for a typical title against 1.6s
  // before, or 2.3s for a long German one.
  var titleEl = root.querySelector('[data-pp-letter-split]');
  if (titleEl && !reduce) {
    var text = (titleEl.textContent || '').trim();
    if (text) {
      titleEl.textContent = '';
      var i = 0;
      text.split(/(\s+)/).forEach(function (chunk) {
        if (!chunk) return;
        if (/^\s+$/.test(chunk)) { titleEl.appendChild(document.createTextNode(' ')); return; }
        var word = document.createElement('span');
        word.className = 'ppm-word ppm-letter';
        word.textContent = chunk;
        word.style.animationDelay = (200 + i * 90) + 'ms';
        titleEl.appendChild(word);
        i++;
      });
    }
  }

  // --- Number counters (animate from 0 to data-count) ---------------------
  function animateCounter(el) {
    var target = parseInt(el.getAttribute('data-count'), 10) || 0;
    if (target === 0) { el.textContent = '0'; return; }
    var duration = Math.min(1400, 400 + target * 25);
    var start = performance.now();
    function frame(now) {
      var t = Math.min((now - start) / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = Math.round(target * eased).toString();
      if (t < 1) requestAnimationFrame(frame);
      else el.textContent = target.toString();
    }
    requestAnimationFrame(frame);
  }

  // Use the existing IO for counters too (consolidate)
  var counters = root.querySelectorAll('.ppm-counter');
  if (counters.length && 'IntersectionObserver' in window && !reduce) {
    var ioC = observe(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCounter(e.target);
          ioC.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { ioC.observe(c); });
  } else if (counters.length) {
    counters.forEach(animateCounter);
  }

  // --- Magnetic CTA buttons -----------------------------------------------
  if (!reduce && window.matchMedia('(pointer: fine)').matches) {
    root.querySelectorAll('.ppm-magnetic').forEach(function (el) {
      var rect = null;
      function onMove(e) {
        if (!rect) rect = el.getBoundingClientRect();
        var dx = (e.clientX - rect.left - rect.width / 2) * 0.15;
        var dy = (e.clientY - rect.top - rect.height / 2) * 0.25;
        el.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
      }
      function onLeave() {
        rect = null;
        el.style.transform = '';
      }
      on(el, 'mouseenter', function () { rect = el.getBoundingClientRect(); });
      on(el, 'mousemove', onMove);
      on(el, 'mouseleave', onLeave);
    });
  }
  return function destroy() {
    ac.abort();
    observers.forEach(function (io) { io.disconnect(); });
    timers.forEach(clearTimeout);
  };
}

// --- Boot + Shopify section lifecycle ---------------------------------------
(function () {
  var instances = new WeakMap();
  function boot(scope) {
    (scope || document).querySelectorAll('[data-pp-product]').forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, ppModernInit(root) || function () {});
    });
  }
  function teardown(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-pp-product]').forEach(function (root) {
      var destroy = instances.get(root);
      if (destroy) { destroy(); instances.delete(root); }
    });
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });
  boot(document);
})();
